import React from 'react';
import { QuizContainerBlock } from '../platformui/';
export default (props) => (
  <QuizContainerBlock
    heading={props.Heading}
    introText={props.Description}
    link={props.Link}
    linkText={props.LinkText}
    internalLinkName={props.InternalLink}
    questions={props.MainContent}
    blockId={props.BlockId}
    answerSpans={props.AnswerSpans}
    chapterContainerHasHeading={props.isH3}
    isCollectionPage={props.CurrentPageProps.PageTypeName === 'CollectionPage'}
    shareButton={props.ShareButton?.[0]}
  />
);
